import { Routes, Route, Navigate } from "react-router-dom";
import React, { Suspense } from "react";
import RoleGuard from "./components/guards/RoleGuard";
import { lazy } from "react";
const AdminUser = lazy(() => import("./components/admin/AdminUser"));
const AdminEmail = lazy(() => import("./components/admin/AdminEmail"));
const AdminLog = lazy(() => import("./components/admin/AdminLog"));
const NotFoundPage = lazy(() => import("./components/NotFoundPage"));
const Settings = lazy(() => import("./components/Settings"));
const TimerDashboard = lazy(() => import("./components/timer/TimerDashboard"));
const RunningTimer = lazy(() => import("./components/timer/RunningTimer"));
const PastTimers = lazy(() => import("./components/timer/PastTimers"));
const Tags = lazy(() => import("./components/Tags"));
const PointMultipliers = lazy(() => import("./components/PointMultipliers"));
const Planning = lazy(() => import("./components/Planning"));

export function LoggedInRouter() {
  const routes = [
    {
      path: "/",
      element: <TimerDashboard />,
    },
    {
      path: "/login",
      element: <Navigate to="/" replace />,
    },
    {
      path: "/browser-automation-login",
      element: <Navigate to="/" replace />,
    },
    { path: "/running", element: <RunningTimer /> },
    {
      path: "/settings",
      element: <Settings />,
    },
    { path: "/past", element: <PastTimers /> },
    { path: "/tags", element: <Tags /> },
    { path: "/multipliers", element: <PointMultipliers /> },
    { path: "/planning", element: <Planning /> },
    {
      path: "/admin/users",
      element: (
        <RoleGuard roles={["admin"]}>
          <AdminUser />
        </RoleGuard>
      ),
    },
    {
      path: "/admin/email",
      element: (
        <RoleGuard roles={["admin"]}>
          <AdminEmail />
        </RoleGuard>
      ),
    },
    {
      path: "/admin/log",
      element: (
        <RoleGuard roles={["admin"]}>
          <AdminLog />
        </RoleGuard>
      ),
    },
    {
      path: "/admin",
      element: (
        <RoleGuard roles={["admin"]}>
          <Navigate to="/admin/users" replace />
        </RoleGuard>
      ),
    },
    {
      path: "*",
      element: <NotFoundPage />,
    },
  ];

  return (
    <Suspense fallback={<div />}> 
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    </Suspense>
  );
}
